import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Header } from "@/components/Header";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("Le mot de passe doit contenir au moins 6 caractères");
    setLoading(true);
    try {
      await register(name, email, password);
      toast.success("Compte créé avec succès");
      navigate(location.state?.from || "/mes-videos");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-luxe min-h-screen">
      <Header />
      <div className="max-w-md mx-auto px-6 pt-36 pb-24">
        <h1 className="font-display text-3xl text-[#F5F3EE] text-center">Créer un compte</h1>
        <p className="mt-3 text-sm text-[#8F8F8F] text-center">
          Créez votre compte pour acheter et regarder vos vidéos
        </p>
        <form onSubmit={submit} className="mt-10 bg-[#141414] border border-white/10 p-8 space-y-5" data-testid="register-form">
          <div>
            <Label htmlFor="name" className="text-xs uppercase tracking-widest text-[#8F8F8F]">Nom complet</Label>
            <Input
              id="name" data-testid="register-name-input" value={name}
              onChange={(e) => setName(e.target.value)} placeholder="Jean Dupont" required
              className="mt-2 rounded-none border-white/15 bg-transparent text-[#F5F3EE] placeholder:text-[#5A5A5A] focus-visible:ring-[#D4AF37]"
            />
          </div>
          <div>
            <Label htmlFor="email" className="text-xs uppercase tracking-widest text-[#8F8F8F]">Email</Label>
            <Input
              id="email" type="email" data-testid="register-email-input" value={email}
              onChange={(e) => setEmail(e.target.value)} placeholder="jean@email.com" required
              className="mt-2 rounded-none border-white/15 bg-transparent text-[#F5F3EE] placeholder:text-[#5A5A5A] focus-visible:ring-[#D4AF37]"
            />
          </div>
          <div>
            <Label htmlFor="password" className="text-xs uppercase tracking-widest text-[#8F8F8F]">Mot de passe</Label>
            <Input
              id="password" type="password" data-testid="register-password-input" value={password}
              onChange={(e) => setPassword(e.target.value)} placeholder="6 caractères minimum" required
              className="mt-2 rounded-none border-white/15 bg-transparent text-[#F5F3EE] placeholder:text-[#5A5A5A] focus-visible:ring-[#D4AF37]"
            />
          </div>
          <button
            type="submit" data-testid="register-submit-button" disabled={loading}
            className="w-full bg-[#D4AF37] text-[#0A0A0A] font-semibold py-4 text-sm uppercase tracking-widest hover:bg-[#C9A227] transition-colors disabled:opacity-60 flex items-center justify-center gap-2"
          >
            {loading && <Loader2 className="w-4 h-4 animate-spin" />} Créer mon compte
          </button>
          <p className="text-center text-sm text-[#8F8F8F]">
            Déjà un compte ?{" "}
            <Link to="/connexion" state={location.state} data-testid="go-login-link" className="underline text-[#D4AF37]">
              Se connecter
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}
